import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {mdiContentCopy} from "@mdi/js";
import {ref} from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'CopyToClipboardButton',
  props: {
    text: {}
  },
  setup(__props: any) {

const clipboardCopyAsync = () => import("clipboard-copy").then(p => p.default);

const props = __props;

const showsCopied = ref(false);

async function copy() {
  const clipboardCopy = await clipboardCopyAsync()
  await clipboardCopy(props.text);
  showsCopied.value = true;
  await new Promise(resolve => setTimeout(resolve, 2000));
  showsCopied.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createBlock(_component_v_tooltip, {
    "model-value": showsCopied.value,
    location: "bottom",
    disabled: ""
  }, {
    activator: _withCtx(({props}) => [
      _createVNode(_component_v_btn, _mergeProps({
        onClick: _cache[0] || (_cache[0] = ($event: any) => (copy()))
      }, props, {
        icon: _unref(mdiContentCopy),
        variant: "text"
      }), null, 16, ["icon"])
    ]),
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("span", null, "Copied", -1))
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})